import React from "react";
import jwt_decode from "jwt-decode";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { openModal } from "../../../Library/ModalPopUp";
import { CPDPInfo } from "./CPDPInfo";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export const CPDPProgress = ({ value, max, studentid }) => {

  console.log(AuthDecode.TypeCK);

  const percentage = (value / max) * 100;
  const remainingQuota = max - value;
  const is_pass = value >= max ? true : false;
  const DetailCPDP = () => {
      if (value > 0) {
        openModal({ header: `CPDP Point Acquisition Details`, message: <CPDPInfo studentid={studentid} cpdp_points={value} max_points={max} />, size: "xl" })
      }
  }
  return (
    <div className="cursor-pointer" onClick={() => { DetailCPDP() }}>
      <div className="d-sm-flex align-items-start justify-content-between">
        <div className="d-sm-flex align-items-center">
          <div style={{ width: 80, height: 80 }} className="text-center">
            <CircularProgressbar
              value={percentage}
              text={`${value}/100`}
              strokeWidth={10}
              styles={buildStyles({
                pathColor: "#369AFF",
                textColor: "#000",
                textSize: 20,
              })}
            />
          </div>
          <div className="ml-sm-5">
            {is_pass ? (
              <div className="mt-3 mt-sm-0">
                <span className="font-weight-boldest font-size-h2 d-block">
                  CPDP Point : <span className="text-primary">{value}</span>
                </span>
                <span className="font-weight-boldest font-size-h2 mt-2">
                  Target Point : <span className="text-primary">{max}</span>
                </span>
              </div>
            ) : (
              <div className="mt-3 mt-sm-0">
                <span className="font-weight-boldest font-size-h2 d-block">
                  CPDP Point : <span className="text-primary">{value}</span>
                </span>
                <span className="font-weight-boldest font-size-h2 mt-2">
                  Remaining : <span className="text-danger">{remainingQuota}</span>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="text-center mt-3">
        <div className={`badge badge-${is_pass ? 'primary' : 'danger'} w-100 py-3 h6`}>
          <span className="font-size-md font-weight-boldest">{is_pass ? 'COMPLETED' : 'INCOMPLETE'}</span>
        </div>
      </div>
    </div>
  );
};
